import { render, staticRenderFns } from "./MagSubMenu.vue?vue&type=template&id=73b4caa8&scoped=true"
import script from "./MagSubMenu.vue?vue&type=script&lang=js"
export * from "./MagSubMenu.vue?vue&type=script&lang=js"
import style0 from "./MagSubMenu.vue?vue&type=style&index=0&id=73b4caa8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b4caa8",
  null
  
)

export default component.exports